import styled from '@emotion/styled';
import { H2, Text } from 'ds/components/typography';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';
import { BreakpointValue } from 'consts/breakpoints';
import { ContentWrapper } from 'screens/DevelopersSearchPage/styled';
import { colorToAlpha } from 'helpers/insight';

export const screenToImageWidth: Record<BreakpointValue, number> = {
  1: 446,
  2: 326,
  3: 409,
  4: 409,
  5: 409,
};

export const CoverWrapper = styled.div`
  ${({ theme }) => `
    position: relative;
    background-color: ${theme.colors.neutrals.grey11};
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    height: 510px;
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    height: 382px;
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: 446px;
  `}
`;

export const CoverInner = styled(ContentWrapper)`
  position: relative;
  z-index: 10;

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    padding-top: ${theme.spacing(18)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    padding-top: ${theme.spacing(9)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-top: ${theme.spacing(16)};
    text-align: center;
  `}
`;

export const CoverImage = styled.div<{ src: string; }>`
  position: absolute;
  left: 0;
  bottom: -2px;

  ${({ theme, src }) => theme.media.showAt({ at: 1 })`
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${theme.colors.neutrals.white};
    background-image: url("${src}");
    transform-origin: top left;
    background-size: cover;
    top: 0;
  `}
`;

export const Title = styled(H2.withComponent('h1'))`
  ${({ theme }) => `
    color: ${theme.colors.brand.light};
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    font-size: ${typographyFontSizeCfg.display.desktop}px;
    line-height: ${typographyLineHeightCfg.display.desktop};
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    font-size: 34px;
    line-height: 58px;
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    color: ${theme.colors.neutrals.white};
  `}
`;

export const Description = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey3};
  `}
${({ theme }) => theme.media.showAt({ from: 4 })`
  font-size: ${typographyFontSizeCfg.h3.desktop}px;
  line-height: ${typographyLineHeightCfg.h3.desktop}px;
`}
${({ theme }) => theme.media.showAt({ from: 3 })`
  margin-top: ${theme.spacing(2)};
  white-space: pre;
`}
${({ theme }) => theme.media.showAt({ at: 2 })`
  font-size: ${typographyFontSizeCfg.smallText}px;
  line-height: ${typographyLineHeightCfg.smallText}px;
  width: 370px;
`}
${({ theme }) => theme.media.showAt({ at: 1 })`
  margin: ${theme.spacing(1)} auto 0;
  color: ${theme.colors.neutrals.white};
  max-width: 280px;
`}
`;

export const SearchWrapper = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.spacing(4)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(2)};
  `}
`;

export const CoverImageOverlay = styled.div`
  ${({ theme }) => `
    height: 100%;
    width: 100%;
    background-color: ${colorToAlpha(theme.colors.neutrals.grey2, 0.74)}
  `}
`;
